import { createContext } from 'react';
export const DefaultDeviceControlContextState = {
    supportsABE: false,
    payloadDefintionName: null,
    resolvedDownlinkAttributes: null,
    rangeLimits: null,
    correspondingUplinkAttributeMap: null,
};
const isSIMPLE_UPDATE_ACTION = (action) => action.type === 'SIMPLE_UPDATE';
export const DeviceControlContextReducer = (state, action) => {
    if (isSIMPLE_UPDATE_ACTION(action)) {
        return {
            ...state,
            ...action.value,
        };
    }
    return state;
};
export const DeviceControlContext = createContext({
    state: DefaultDeviceControlContextState,
    dispatch: (action) => {
        throw new Error(`DeviceControlContext dispatch not initialized!: ${action.type}`);
    },
});
